<template>
  <div id="wrapper" class="page">
    <qtake-side-bar index="3"/>
    <div id="content-wrapper">
        <div class="container-fluid">
          <button class="btn btn-info mb-2" @click.prevent="openPriceModal">
            <i class="fas fa-plus"></i> Add a price
          </button>
          <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="price_fields"
          :items="price_items"
        >
          <template v-slot:cell(action)="data">
            <b-link class="text-primary mr-2" href="#" @click.prevent="openUpdatePriceModal(data)">
                <i class="fas fa-pencil-alt"></i>
            </b-link>
            <b-link class="text-danger" href="#" @click.prevent="deletePrice(data)">
                <i class="fas fa-trash"></i>
            </b-link>
          </template>
          <template v-slot:cell(price_playback)="data">{{data.item.price_playback | numeral('0,0')}}  USD</template>
          <template v-slot:cell(price_playback_livestream)="data">{{data.item.price_playback_livestream | numeral('0,0')}}  USD</template>
          <template v-slot:cell(fromdate)="data">
            {{data.item.fromdate | moment("DD/MM/YYYY")}}
          </template>
          <template v-slot:cell(todate)="data">
            {{data.item.todate | moment("DD/MM/YYYY")}}
          </template>
          <template v-slot:cell(isinternal)="data">
            <i v-if="data.item.isinternal" style="color:green" class="fas fa-check"/>
          </template>
        </b-table>
        </div>
    </div>

    <!-- PRICE MODAL -->
    <b-modal
      v-model="priceModalShow"
      @hidden="closePriceModal"
      header-bg-variant="info"
      header-text-variant="light"
    >
    <template v-slot:modal-title>
      <div v-if="is_creating_price">Add a Price</div>
      <div v-else>Update a Price</div>
    </template>
    <template v-slot:modal-footer>
        <b-button variant="info" @click="submitPrice"><i class="fas fa-save mr-2"></i>Save</b-button>
        <b-button variant="secondary" @click="closePriceModal"><i class="fas fa-times mr-2"></i>Cancel</b-button>
      </template>
    <b-container>
      <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Playback price:
              </template>
              <my-currency-input v-model="price.price_playback"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Playback Livestream price:
              </template>
              <my-currency-input v-model="price.price_playback_livestream"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Management fee rate:
              </template>
              <b-form-input type="number" step="0.01" v-model="price.managementfee_rate"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>Apply from date:
              </template>
              <my-date-picker v-model="fromdate_selected"/>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template v-slot:label>Apply to date:
              </template>
              <my-date-picker v-model="todate_selected"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-checkbox v-model="price.isinternal">Internal</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
    </b-container>
    </b-modal>
    <!-- END OF PRICE MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import QtakeSideBar from "../components/Qtake/QtakeSideBar";
import MyDatePicker from  "../components/App/MyDatePicker";
import MyCurrencyInput from "../components/App/MyCurrencyInput";

export default {
  name: 'QtakeDepartmentPrices',
  components: {
    QtakeSideBar,
    MyCurrencyInput,
    MyDatePicker,
  },
  data() {
    return {
      priceModalShow: false,
      price_fields: [
        {
          key: "price_playback",
          label: "Playback price",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "price_playback_livestream",
          label: "Playback & Livestream price",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "price_playback",
          label: "Playback price",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "managementfee_rate",
          label: "Management Price",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "isinternal",
          label: "Internal",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "fromdate",
          label: "Apply from date",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "todate",
          label: "Apply to date",
          thClass: "align-middle",
          tdClass: "text-center",
          thStyle: { textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],
      price_items: [],
      price: {
        id: 0,
        price_playback: 0,
        price_playback_livestream: 0,
        managementfee_rate: 0.25,
        fromdate: null,
        todate: null,
        isinternal: true,

        // Not-mapped
        index: null,
      },
      fromdate_selected: "",
      todate_selected: "",
      price_flush: null,
      is_creating_price: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    axios.get("/api/qtakedepartmentprice")
      .then((response) => {next((vm) => vm.initData(response.data));})
      .catch((err) => {next();});
  },
  methods: {
    initData(prices) {
      this.price_items = prices;
      this.price_flush = this.$copy(this.price);
    },
    openPriceModal() {
      this.priceModalShow = true;
      this.todate_selected = "31/12/" + new Date().getFullYear();
      this.is_creating_price = true;
    },
    closePriceModal() {
      this.price = this.$copy(this.price_flush);
      this.fromdate_selected = "",
      this.todate_selected = "",
      this.priceModalShow = false;
      this.is_creating_price = false;
    },
    openUpdatePriceModal(data) {
      this.price = JSON.parse(JSON.stringify(data.item));
      this.fromdate_selected = this.$convert_date_string(data.item.fromdate);
      this.todate_selected = this.$convert_date_string(data.item.todate);
      this.price.index = data.index;
      this.priceModalShow = true;
    },
    submitPrice() {
      if (this.fromdate_selected == "") {
        this.$error_message("Please choose apply from date", true);
        return;
      }

      this.price.managementfee_rate = parseFloat(this.price.managementfee_rate);
      this.price.fromdate = this.$convert_string_date(this.fromdate_selected);
      this.price.todate = this.$convert_string_date(this.todate_selected);

      if (this.is_creating_price) this.addPrice();
      else this.updatePrice();
    },
    addPrice() {
      axios.post("/api/qtakedepartmentprice", this.price)
      .then((res) => {
        this.price_items.push(res.data);
        this.$success_message("Add date successfully", true);
      })
      .catch((err) =>{this.$error_message(err.response.data)});
    },
    updatePrice() {
      axios.put("/api/qtakedepartmentprice", this.price)
      .then((res) => {
        this.price_items = this.$insert_array_parse_json(res.data, this.price_items);
        this.$success_message("Update date successfully", true);
        this.closePriceModal();
      })
      .catch((err) =>{this.$error_message(err.response.data, true)});
    },
    deletePrice(data) {
      this.$toast.question("Do you really want to delete this?", "Warning", {
        timeout: 20000, close: false, overlay: true, displayMode: "once", position: "center", buttons:
        [["<button><b>Yes</b></button>", (instance, toast) => {
              axios.delete(`/api/qtakedepartmentprice/${data.item.id}`)
              .then((res) => {
                this.price_items.splice(data.index, 1);
                this.$success_message("Successfully delete!", true);
              })
              .catch((err) => {this.$error_message(err.response.data, true)});
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true
          ],
          ["<button>No</button>", (instance, toast) => {instance.hide({ transitionOut: "fadeOut" }, toast, "button");},],
        ],
      });
    },
  }
}
</script>